import axios from "axios";
import { API_ROOT } from ".";

const MEMBERSHIP_PURCHASE_API_URL = `${API_ROOT}/membership-purchase`;

export async function createMembershipPurchaseSession(
  contentfulId: string,
): Promise<{ checkoutUrl: string | null; sessionId: string }> {
  const res = await axios.post<{ checkoutUrl: string | null; sessionId: string }>(
    `${MEMBERSHIP_PURCHASE_API_URL}/checkout-session`,
    { contentfulId },
  );
  return res.data;
}
